module.exports = __webpack_public_path__ + "prod/1.42.2/img/api-three.6df8e40e.png";